<template>
  <div class="wrapper">
    <span class="w-title">{{ adding?'新建科目余额':(editing ? "修改科目余额" : "文档科目余额") }}</span>
    <v-divider class="my-3"/>
    <v-container fluid grid-list-md class="xn-form pa-0">
      <div class="detail-btns">
        <v-btn color="info" flat @click="cancel">&lt; 返回科目余额列表</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="!adding" color="error" flat outline @click="deleteThisItem">删除</v-btn>
        <v-btn v-if="detailing" color="info" flat class="btn-to-edit" @click="toEdit">去编辑 &gt;</v-btn>
      </div>
      <div class="form-panel">
        <div class="form-panel-head">基本信息</div>
        <div class="form-panel-body">
          <v-container fluid grid-list-md class="pa-0">
            <v-layout wrap>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="editing||adding?'required':''">公司:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-autocomplete
                  ref="form.companyId"
                  v-model="item.companyId"
                  no-data-text="无可用数据"
                  :items="companies"
                  :label="detailing?'':'请选择公司'"
                  :rules="[rules.required]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="editing||adding?'required':''">申报月份:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-menu
                  v-model="showStartDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      ref="form.month"
                      label="申报月份"
                      readonly
                      :rules="[rules.required]"
                      outline
                      solo
                      :disabled="detailing"
                      :value="item.month&&item.month.substring(0,7)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="item.month"
                    locale="zh-cn"
                    type="month"
                    @input="showStartDate = false;item.month=item.month+'-01'"
                  ></v-date-picker>
                </v-menu>
              </v-flex>


              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="editing||adding?'required':''">文档:</label>
              </v-flex>
              <v-flex v-if="item.documentInternalName" xs9 md10>
                <v-btn
                  style="margin-right: 10px !important;"
                  color="primary"
                  :href="documentUrl"
                  target="_blank"
                >
                  查看现有文档
                </v-btn>
                <v-label>{{ item.documentFileName }}</v-label>
              </v-flex>
              <v-flex v-if="!item.documentInternalName" xs9 md10>
                <upload-btn
                  title="上传文件"
                  accept="application/pdf,image/jpeg,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  no-title-update
                  style="padding: 0;"
                  @file-update="fileUpdate"
                >
                </upload-btn>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
              </v-flex>
              <v-flex xs9 md10>
                <upload-btn
                  v-if="item.documentInternalName && editing"
                  accept="application/pdf,image/jpeg,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  title="如需更换现有文档，请选择文件"
                  no-title-update
                  style="padding: 0"
                  @file-update="fileUpdate"
                >
                </upload-btn>
              </v-flex>
              <v-flex xs3 md2 class="d-flex mt-2">
              </v-flex>
              <v-flex xs9 md10>
                <v-chip v-if="file" close @input="clearFile">
                  {{
                    file.name
                  }}
                </v-chip>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </div>
    </v-container>


    <v-container fluid grid-list-md class="pa-0 my-5">
      <v-layout>
        <v-flex xs3 md4></v-flex>
        <v-flex xs6 md4 style="display:flex;justify-content: space-around">
          <v-btn outline @click="cancel">返回</v-btn>
          <v-btn v-if="!detailing" color="info" @click="save">保存</v-btn>
        </v-flex>
        <v-flex xs3 md4></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import UploadButton from "vuetify-upload-button";
  import {mapState, mapActions} from "vuex";
  import axios from "../axios";

  export default {
    name: "BalanceForm",
    components: {
      "upload-btn": UploadButton,
    },
    computed: {
      ...mapState({
        showLoading: state => state.showLoading,
        companies: state => state.miniCompanies,
        companiesMap: state => state.miniCompaniesMap
      }),
      id() {
        return this.$route.params.balanceId;
      },
      adding() {
        return !this.$route.params.balanceId;
      },
      editing() {
        return (!!this.id) && this.$route.name === "balance-form-edit"
      },
      detailing() {
        return (!!this.id) && this.$route.name === "balance-form-detail"
      },
      documentUrl() {
        return (
          process.env.VUE_APP_API + 'assets/' + this.item.documentInternalName
        );
      }
    },
    data: () => {
      return {
        rules: {
          required: value => !!value || "必填",
          length5: value => (!!value && value.length >= 5) || "长度至少为5",
          length8: value => (!!value && value.length >= 8) || "长度至少为8",
          phoneNumber: value => {
            const pattern = /^1\d{10}$/;
            return pattern.test(value) || "请输入正确的手机号";
          },
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            // eslint-disable-next-line
            return (typeof value === "undefined" || value === null || value === "" || pattern.test(value)) || "请输入正确的邮箱";
          }
        },
        item: {},
        showStartDate: false,
        file: null,
        hasErrors: false
      };
    },
    methods: {
      ...mapActions(["setLoading"]),
      resetForm() {
        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          )
            this.$refs["form." + f].resetValidation();
        });
      },
      cancel() {
        this.$router.push({name: 'balances'});
      },
      toEdit() {
        this.$router.push("edit");
      },
      deleteThisItem() {
        this.$confirm("确定删除?").then(
          res => {
            if (res) {
              let arr = [];
              arr.push(this.$route.params.balanceId);
              this.setLoading(true);
              axios
                .post("/balance/delete", {
                  balanceIds: arr
                })
                .then(() => {
                  this.setLoading(false);

                  this.$confirm("删除成功", {buttonFalseText: null}).then(() => {
                      this.cancel();
                    }
                  );
                })
                .catch(reason => {
                  this.$confirm(reason.response.data.message, {
                    buttonFalseText: null
                  });
                  this.setLoading(false);
                });
            }
          }
        );
      },
      save() {
        this.validate();
        if (!this.hasErrors) {
          if (this.editing) {
            this.setLoading(true);
            let formData = new FormData();
            formData.append("file", this.file);
            formData.append("data", JSON.stringify(this.item));
            axios
              .put("/balance/" + this.item.balanceId, formData, {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              })
              .then(() => {
                this.setLoading(false);

                this.$confirm("修改成功", {buttonFalseText: null}).then(() => {
                  this.cancel();
                });
              })
              .catch(reason => {
                this.$confirm(reason.response.data.message, {
                  buttonFalseText: null
                });
                this.setLoading(false);
              });
          } else {
            if (!this.file) {
              this.$confirm('文档不能为空', {
                buttonFalseText: null
              });
              return;
            }
            this.setLoading(true);
            let formData = new FormData();
            formData.append("file", this.file);
            this.item.documentFileName = this.file.name;
            formData.append("data", JSON.stringify(this.item));
            axios
              .post("/balance", formData, {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              })
              .then(() => {
                this.setLoading(false);

                this.$confirm("创建成功", {buttonFalseText: null}).then(() => {
                  this.cancel();
                });
              })
              .catch(reason => {
                this.$confirm(reason.response.data.message, {
                  buttonFalseText: null
                });
                this.setLoading(false);
              });
          }
        }
      },
      fileUpdate(file) {
        this.file = file;
      },
      clearFile() {
        this.file = null;
      },
      validate() {
        this.hasErrors = false;
        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          ) {
            if (!this.$refs["form." + f].validate(true)) {
              this.hasErrors = true;
            }
          }
        });
      }
    },
    created() {
      if (this.editing || this.detailing) {
        this.setLoading(true);
        axios.get("/balance/" + this.$route.params.balanceId).then(res => {
          this.item = res.data;
          this.setLoading(false);
        })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {
              buttonFalseText: null
            });
            this.setLoading(false);
          });
      } else {
        this.clearFile();
        this.item = {
          companyId: null,
          month:null
        };
      }
    }
  };
</script>

<style scoped></style>
